/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 201 created object
 * @export
 * @interface PostFleetsFleetIdWingsCreated
 */
export interface PostFleetsFleetIdWingsCreated {
    /**
     * The wing_id of the newly created wing
     * @type {number}
     * @memberof PostFleetsFleetIdWingsCreated
     */
    wingId: number;
}

/**
 * Check if a given object implements the PostFleetsFleetIdWingsCreated interface.
 */
export function instanceOfPostFleetsFleetIdWingsCreated(value: object): value is PostFleetsFleetIdWingsCreated {
    if (!('wingId' in value) || value['wingId'] === undefined) return false;
    return true;
}

export function PostFleetsFleetIdWingsCreatedFromJSON(json: any): PostFleetsFleetIdWingsCreated {
    return PostFleetsFleetIdWingsCreatedFromJSONTyped(json, false);
}

export function PostFleetsFleetIdWingsCreatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostFleetsFleetIdWingsCreated {
    if (json == null) {
        return json;
    }
    return {
        
        'wingId': json['wing_id'],
    };
}

export function PostFleetsFleetIdWingsCreatedToJSON(json: any): PostFleetsFleetIdWingsCreated {
    return PostFleetsFleetIdWingsCreatedToJSONTyped(json, false);
}

export function PostFleetsFleetIdWingsCreatedToJSONTyped(value?: PostFleetsFleetIdWingsCreated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'wing_id': value['wingId'],
    };
}

